import http from "@/plugins/Axios";
import { makerPagination } from "@/utils/pureFunctions";

export default {
  actions: {
    async getWareHouses(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("warehouse/items", {
          params,
        });
        return {
          data,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getCustomers(_, params = {}) {
      try {
        const {
          data: { data, total },
        } = await http.get("customer/list", {
          params,
        });
        return {
          data,
          total,
          lastPage: params.limit
            ? makerPagination({ limit: params.limit, total }).lastPage
            : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getOutgoingContracts(_, query) {
      try {
        const {
          data: { data },
        } = await http.get("outgoing-contract/list", {
          params: {
            name: query && query.name,
            isNotCompleted: query && query.isNotCompleted,
          },
        });
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getInfoByQr(_, qrCode) {
      try {
        const {
          data: { data },
        } = await http.get(`product-item/qr-code/full-info/${qrCode}`);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getUnitTypeList(_, query) {
      try {
        const {
          data: { data },
        } = await http.get("unit-type/list", {
          params: {
            name: query && query.name,
            limit: query && query.limit,
          },
        });
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getWarehouseGroups(_, query) {
      try {
        const params = query || {};
        const {
          data: { data, total },
        } = await http.get("warehouse-group", {
          params,
        });
        return {
          data,
          lastPage:
            query && query.limit
              ? makerPagination({ limit: query.limit, total }).lastPage
              : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
